/*
 * Code-toggleable feature flags. Introduced for BOWN-132 (KOT kill switch).
 * Values are read from VUE_APP_* env vars at build time so flipping a flag
 * is a redeploy with a different env, not a code change.
 */
const flags = {
    kot: process.env.VUE_APP_KOT_ENABLED === "true",
} as const;

export type FeatureFlag = keyof typeof flags;

export function isFeatureEnabled(flag: FeatureFlag): boolean {
    return flags[flag];
}
